var map = {
	"./_default.json": 435,
	"./ancot.json": 436,
	"./bmarken.json": 437,
	"./cittaviva.json": 438,
	"./class.json": 439,
	"./coop.json": 440,
	"./crai.json": 441,
	"./csp.json": 442,
	"./doreca.json": 443,
	"./doro.json": 444,
	"./ekom.json": 445,
	"./enel.json": 446,
	"./fashionzclub.json": 447,
	"./gdsp.json": 448,
	"./goovi.json": 449,
	"./lcng.json": 450,
	"./lie.json": 451,
	"./mauto.json": 452,
	"./mysarca.json": 453,
	"./retex-bistrot.json": 454,
	"./retex.json": 455,
	"./self-service.json": 456,
	"./smarttouch.json": 457,
	"./smkt.json": 458,
	"./voghera.json": 459,
	"./wikimuseo.json": 460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 807;